export default class Account {
    constructor() {
        this.id;
        this.providerId;
        this.patientId;
        this.accountStatus;
        this.createdAt;
        this.processedAt;
        this.acceptedAt;
        //this.faceValue;
        this.grvNumber;
        this.invoiceNumber;
        this.isPaid;
        this.isDeleted;
        this.createdByUserId;
        this.accountFiles = [];
        this.patient;
        this.notes;
        this.clinicalNotes;
        this.discipline;
        this.providerAdminFeePercentage;
        this.providerPrefundFeePercentage;
        this.isFinalAccount;
        this.fundingType;
        this.linkNumber;
        this.paidAmount;
        this.paidDate;
        this.podFileId;
        this.acceptedEmailSentAt;
        this.verifiedAt;
        this.verifiedEmailSentAt;
        this.fundingTypeOverride;
        this.queryText = "";
        this.paymentDueDate;
        this.paymentRunPeriod;
        this.caseReviewDate;
        this.isPartlyAccepted;
        this.partlyAcceptedFaceValue;
        this.claimId;
        
        this.hasPrefundFunding;
        this.hasAdminFunding;
        this.faceValuePrefund;
        this.faceValueAdmin;
        this.grvNumberPrefund;
        this.grvNumberAdmin;
        this.claimedHasPrefundFunding;
        this.claimedHasAdminFunding;
        this.claimedPurchaseValuePrefund;
        this.claimedPurchaseValueAdmin;
        this.paidAmountPrefund;
        this.paidAmountAdmin;
        this.paidDatePrefund;
        this.paidDateAdmin;
        this.isPaidPrefund;
        this.isPaidAdmin;

        this.serviceProviderTotalFaceValue;

        this.billingItemId;
        this.billingId;
        this.billingQueries;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.providerId = setEntity.providerId;
        this.patientId = setEntity.patientId;
        this.accountStatus = setEntity.accountStatus;
        this.createdAt = setEntity.createdAt;
        this.processedAt = setEntity.processedAt;
        this.acceptedAt = setEntity.acceptedAt;
        //this.faceValue = setEntity.faceValue;
        this.grvNumber = setEntity.grvNumber;
        this.invoiceNumber = setEntity.invoiceNumber;
        this.isPaid = setEntity.isPaid;
        this.isDeleted = setEntity.isDeleted;
        this.createdByUserId = setEntity.createdByUserId;
        this.accountFiles = setEntity.accountFiles ? setEntity.accountFiles : [];
        this.patient = setEntity.patient;
        this.discipline = setEntity.discipline;
        this.providerAdminFeePercentage = setEntity.providerAdminFeePercentage;
        this.providerPrefundFeePercentage = setEntity.providerPrefundFeePercentage;
        this.isFinalAccount = setEntity.isFinalAccount;
        this.notes = setEntity.notes ? setEntity.notes : [];
        this.clinicalNotes = setEntity.clinicalNotes ? setEntity.clinicalNotes : [];
        this.fundingType = setEntity.fundingType;
        this.linkNumber = setEntity.linkNumber;
        this.paidAmount = setEntity.paidAmount;
        this.paidDate = setEntity.paidDate;
        this.podFileId = setEntity.podFileId;
        this.acceptedEmailSentAt = setEntity.acceptedEmailSentAt;
        this.verifiedAt = setEntity.verifiedAt;
        this.verifiedEmailSentAt = setEntity.verifiedEmailSentAt;
        this.fundingTypeOverride = setEntity.fundingTypeOverride;
        this.paymentDueDate = setEntity.paymentDueDate;
        this.paymentRunPeriod = setEntity.paymentRunPeriod;
        this.caseReviewDate = setEntity.caseReviewDate;
        this.isPartlyAccepted = setEntity.isPartlyAccepted;
        this.partlyAcceptedFaceValue = setEntity.partlyAcceptedFaceValue;
        this.claimId = setEntity.claimId;

        this.hasPrefundFunding = setEntity.hasPrefundFunding;
        this.hasAdminFunding = setEntity.hasAdminFunding;
        this.faceValuePrefund = setEntity.faceValuePrefund;
        this.faceValueAdmin = setEntity.faceValueAdmin;
        this.grvNumberPrefund = setEntity.grvNumberPrefund;
        this.grvNumberAdmin = setEntity.grvNumberAdmin;
        this.claimedHasPrefundFunding = setEntity.claimedHasPrefundFunding;
        this.claimedHasAdminFunding = setEntity.claimedHasAdminFunding;
        this.claimedPurchaseValuePrefund = setEntity.claimedPurchaseValuePrefund;
        this.claimedPurchaseValueAdmin = setEntity.claimedPurchaseValueAdmin;
        this.paidAmountPrefund = setEntity.paidAmountPrefund;
        this.paidAmountAdmin = setEntity.paidAmountAdmin;
        this.paidDatePrefund = setEntity.paidDatePrefund;
        this.paidDateAdmin = setEntity.paidDateAdmin;
        this.isPaidPrefund = setEntity.isPaidPrefund;
        this.isPaidAdmin = setEntity.isPaidAdmin;

        this.serviceProviderTotalFaceValue = setEntity.serviceProviderTotalFaceValue;
        this.notReadyForPrinting = setEntity.notReadyForPrinting;

        this.billingItemId = setEntity.billingItemId;
        this.billingId = setEntity.billingId;
        this.billingQueries = setEntity.billingQueries ? setEntity.billingQueries : [];
        /*
        this.notes = [];
        if (setEntity.notes)
            setEntity.notes.forEach((note) => {
                this.notes.push(note);
            });

        this.clinicalNotes = [];
        if (setEntity.clinicalNotes)
            setEntity.clinicalNotes.forEach((clinicalNote) => {
                this.clinicalNotes.push(clinicalNote);
            });

            */

        return this;
    }
}
